import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { Terrain } from './components/Terrain';
import { Basecamp } from './components/Basecamp';
import { Founders } from './components/Founders';
import { TwoDoors } from './components/TwoDoors';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  return <div className="w-full bg-background text-foreground" data-id="element-0" data-mp="2rknmugesbgsx">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-primary focus:px-5 focus:py-3 focus:text-[11px] focus:font-semibold focus:uppercase focus:tracking-label focus:text-primary-foreground" data-id="element-1" data-mp="2rl6tv22wcks6">
        Skip to content
      </a>

      <SiteHeader data-id="element-2" data-mp="28u5x8kp911bs" />

      <main id="main" data-id="element-3" data-mp="28tmdcyg1g2v4">
        <Hero data-id="element-4" data-mp="28t4jg8gum0qd" />
        <Terrain data-id="element-5" data-mp="28sl5f2ubjwhm" />
        <Basecamp data-id="element-6" data-mp="28s2ynca15zvg" />
        <Founders data-id="element-7" data-mp="23vktwcepa1j4" />
        <TwoDoors data-id="element-8" data-mp="23w4clvc6cty7" />
      </main>

      <SiteFooter data-id="element-9" data-mp="23v2s7099qv3t" />
    </div>;
}